import React from 'react';
import PropTypes from 'prop-types';
import V3OfferAdditionalTermsSection from '../V3OfferAdditionalTermsSection';
import { V3_ACTIONS } from '../../contexts/V3OfferContext';

// Per O-3412 direction the Additional Terms tab reuses the existing offer_notes editor
// (V3Offer.additional_terms), not an authored-feed widget.
const SimpleNotesTab = ({ ctrl }) => (
  <div className="simple-offer-card">
    <div className="simple-offer-card__header">
      <div>
        <h3 className="simple-offer-card__title">Additional Terms</h3>
        <p className="simple-offer-card__subtitle">Extra terms printed on the offer.</p>
      </div>
    </div>
    <V3OfferAdditionalTermsSection
      team={ctrl.team}
      csrfToken={ctrl.csrfToken}
      offer={ctrl.offer}
      embedded
      onSaved={(html) => ctrl.dispatch({
        type: V3_ACTIONS.UPDATE_OFFER,
        payload: { additional_terms: html },
      })}
    />
  </div>
);

SimpleNotesTab.propTypes = { ctrl: PropTypes.object.isRequired };

export default SimpleNotesTab;
